<div class="feature-intro">
    <div class="logo-section flex justify-center items-center">
        <app-svg [name]="brandFullLogo" [color]="ss.theme().color35"></app-svg>
    </div>
    <div class="flex flex-col gap-6 items-center">
        <owl-carousel-o class="w-full block intro-carousel" [options]="introOptions" #introCarousel
            (changed)="onItemChanged($event)">
            <ng-template carouselSlide *ngFor="let item of featureIntros; let i = index">
                <div class="intro-section">
                    <div class="img-div">
                        <img [class]="'img-' + (i + 1)" [src]="item.image"
                             [attr.alt]="item.title ? ss.t(item.title, { brandName: BRAND_CONFIG.name }) : ('Feature intro ' + (i + 1))">
                    </div>


                    <div class="content flex flex-col justify-between items-center gap-[54px]">
                        <div class="text-center">
                            <p class="text-16-400 color-8 mb-0 ri-pb-2" *ngIf="item.title">{{ ss.t(item.title, { brandName: BRAND_CONFIG.name }) }}
                            </p>
                            <div class="feature-guide-container color-7 mb-0 text-14-400"
                                [innerHtml]="getContent(item.content)"></div>
                        </div>
                        <div [ngClass]="{'readonly': !item.secondaryButton}">
                            <button class="btn btn-secondary-nav color-35" (click)="openFeatureGuide()">{{
                                item.secondaryButton ? ss.t(item.secondaryButton) : '' }}</button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>

        <div class="contents">
            <button class="btn btn-nav color-12" (click)="nextSlide()">{{ ss.t(currentPosition === 3 ?
                'featureIntro_getStarted' : 'featureIntro_next') }}</button>
        </div>
    </div>


</div>